import { useGlobal } from "reactn";

export const isPremiumUser = () => {
  if (typeof document === "undefined") return false;
  return document.cookie.split(";").some((c) => {
    const [key, value] = c.trim().split("=");
    return key === "ugg_premium" && value === "1";
  });
};

export function useAdFree() {
  const [adblock] = useGlobal("adblock");
  const [isDetectingAdblock] = useGlobal("isDetectingAdblock");

  return adblock || isDetectingAdblock || isPremiumUser();
}
